import LoginContainer from './containers/LoginContainer'

// Sync route definition
export default {
  path      : '/login',
  component : LoginContainer
}



// WEBPACK FOOTER //
// ./src/routes/Login/index.js